import * as React from 'react';
import { Outlet, useNavigate } from 'react-router-dom';

export default function Team() {
    return <Outlet />;
}
